import axios from "axios";

export const baseURL = process.env.REACT_APP_ADVENT_ONE_API_BASE_URL || 'http://localhost:3000'; // Your NestJS server URL
export const isValidNumber = /^[0-9]+$/i;
export const isValidNumberWithForwardSlash = /^[0-9/]+$/i;

axios.defaults.baseURL = baseURL;

// API Queue Tracker — accessible via window.__apiQueue in the browser console
window.__apiQueue = [];

const emitQueueChange = () => {
  window.dispatchEvent(new CustomEvent("apiQueueChange", { detail: { size: window.__apiQueue.length } }));
};

axios.interceptors.request.use((config) => {
  const entry = { url: config.url, method: config.method?.toUpperCase(), params: config.params, startTime: Date.now() };
  window.__apiQueue.push(entry);
  emitQueueChange();
  return config;
});

axios.interceptors.response.use(
  (response) => {
    window.__apiQueue = window.__apiQueue.filter((r) => r.url !== response.config.url);
    emitQueueChange();
    return response;
  },
  (error) => {
    if (error.config) {
      window.__apiQueue = window.__apiQueue.filter((r) => r.url !== error.config.url);
      emitQueueChange();
    }
    return Promise.reject(error);
  }
);
